import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'lib-data-model-customization',
  templateUrl: './data-model-customization.component.html',
  styleUrls: ['./data-model-customization.component.scss'],
  standalone: false
})
export class DataModelCustomizationComponent implements OnInit {

  sidebarItems: string[] = [];
  selectedItem: string = '';
  selectedModelText: string = 'Assets';

  constructor(
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const modelType = params.get('modelType')!;
      
      const data = this.route.snapshot.data;
      this.sidebarItems =
        modelType === 'service-request'
          ? data['serviceRequestSidebarItems'] || []
          : data['sidebarItems'] || [];

      this.selectedModelText = this.mapModelText(modelType);
      this.getSelectedItemByUrlId();
    });
  }

  private mapModelText(type: string | null): string {
    switch (type) {
      case 'assets': return 'Assets';
      case 'service-request': return 'Service Request';
      case 'operations': return 'Operations';
      case 'meter-management': return 'Meter Management';
      case 'customer-management': return 'Customer Management';
      default: return '';
    }
}
  selectDataModel(model: string) {
    this.selectedModelText = model;
    const modelType = model.toLowerCase().replace(' ', '-');

    this.router.navigate(['../../', modelType, 0], { relativeTo: this.route });
  }

  onSidebarItemSelected(item: any) {
    this.selectedItem = item;
    this.cd.detectChanges();
  }

  getSelectedItemByUrlId() {
    const id = +this.route.snapshot.paramMap.get('id')!;
    if (this.selectedModelText != 'Service Request') {
      switch (id) {
        case 0:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE';
          break;
        case 1:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_DEVICES';
          break;
        case 2:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_LINES';
          break;
        case 3:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.BUILDINGS_CUSTOMERS';
          break;
        case 4:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.METERS';
          break;
        case 5:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.SUBSTATION_TEMPLATES';
          break;
      }
    } else {
      switch (id) {
        case 0:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.CUSTOMER_APPLICATION';
          break;
        case 1:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.SERVICE_EXTENSION';
          break;
        case 2:
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.DEDICATED_SUPPLY_REQUESTS';
          break;
        case 3: 
          this.selectedItem = 'DATA_MODEL_CUSTOMIZATION.DISCONNECTION_REQUESTS';
          break;
      } 
    }
  }
}
